module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.name === 'tabs') ? _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n    设置\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "背景色"
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.config.backgroundColor),
      callback: function($$v) {
        _vm.$set(_vm.config, "backgroundColor", $$v)
      },
      expression: "config.backgroundColor"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "默认颜色"
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.config.color),
      callback: function($$v) {
        _vm.$set(_vm.config, "color", $$v)
      },
      expression: "config.color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选中颜色"
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.config.selectedColor),
      callback: function($$v) {
        _vm.$set(_vm.config, "selectedColor", $$v)
      },
      expression: "config.selectedColor"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设置tabBar"
    }
  }, [_vm._l((_vm.data), function(item, index) {
    return _c('div', {
      staticClass: "setting-item"
    }, [(index > 1) ? _c('div', {
      staticClass: "setting-remove",
      on: {
        "click": function($event) {
          return _vm.removeItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-trash-alt"
    })]) : _vm._e(), _vm._v(" "), (item.iconPath) ? _c('img', {
      staticClass: "icon-setter",
      attrs: {
        "src": item.iconPath
      },
      on: {
        "click": function($event) {
          return _vm.handleIconChange(index)
        }
      }
    }) : _c('div', {
      staticClass: "icon-setter",
      on: {
        "click": function($event) {
          return _vm.handleIconChange(index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-image muted"
    })]), _vm._v(" "), (item.selectedIconPath) ? _c('img', {
      staticClass: "icon-setter",
      attrs: {
        "src": item.selectedIconPath
      },
      on: {
        "click": function($event) {
          return _vm.handleSelectedIconChange(index)
        }
      }
    }) : _c('div', {
      staticClass: "icon-setter",
      on: {
        "click": function($event) {
          return _vm.handleSelectedIconChange(index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-image muted"
    })]), _vm._v(" "), _c('div', {
      staticClass: "uploader-setting"
    }, [_c('el-input', {
      attrs: {
        "placeholder": "tab名称",
        "maxlength": ""
      },
      model: {
        value: (item.text),
        callback: function($$v) {
          _vm.$set(item, "text", $$v)
        },
        expression: "item.text"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "uploader-setting"
    }, [_c('el-select', {
      attrs: {
        "placeholder": "设置tab路径"
      },
      on: {
        "focus": function($event) {
          return _vm.handleClick(index)
        },
        "change": _vm.handleChange,
        "blur": function($event) {
          return _vm.handleRemove(index)
        }
      },
      model: {
        value: (item.pagePath),
        callback: function($$v) {
          _vm.$set(item, "pagePath", $$v)
        },
        expression: "item.pagePath"
      }
    }, _vm._l((_vm.pathOptions), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.name == 'custom_link' ? (item.title ? (item.label + ':' + item.title) : item.label) : item.label,
          "value": item.value
        }
      })
    }), 1)], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M （建议尺寸：375px * 200px）")]), _vm._v(" "), _c('el-button', {
    staticClass: "iconfont icon-plus-circle banner-button-uploader",
    attrs: {
      "disabled": _vm.data.length >= 5,
      "type": "default"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v(" 添加菜单项")])], 2)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-62a5a1fa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62a5a1fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_editor/tab_bar.vue
// module id = 2774
// module chunks = 0